import cartEN from "./cart.json";
import confirmationEN from "./confirmation.json";
import customerDetailsEN from "./customerDetails.json";
import glossaryEN from "./glossary.json";
import homeEN from "./home.json";
import summaryEN from "./summary.json";
import controlEN from "./control.json";
import addressEN from "./address.json";
import commonEN from "./common.json";
import validationEN from "./validation.json";
import footerEN from "./footer.json";
import headerEN from "./header.json";
import portinEN from "./portin.json";
import countdownEN from "./countdown.json";

export const cart = cartEN;
export const control = controlEN;
export const confirmation = confirmationEN;
export const customerDetails = customerDetailsEN;
export const home = homeEN;
export const summary = summaryEN;
export const glossary = glossaryEN;
export const address = addressEN;
export const common = commonEN;
export const validation = validationEN;
export const footer = footerEN;
export const header = headerEN;
export const portin = portinEN;
export const countdown = countdownEN;
